import { DependencyContainer } from '../../../DependencyContainer';

export type IntrospectPartnerIds = Record<
  string,
  {
    name: string;
  }
>;

export type Introspect = {
  email: string;
  name: string;
  partnerIds: IntrospectPartnerIds;
  role: string;
};

export default class IntrospectService {
  constructor(private readonly factory: DependencyContainer) {}

  async getIntrospect(): Promise<Introspect> {
    const response = await this.factory.introspectClient.fetchIntrospect();
    return response.data;
  }
}
